import type { ClePubliqueConservee } from '../verification/clePublique';

export interface ProprietesAccueil {
  readonly cle: ClePubliqueConservee | null;
  readonly onScanner: () => void;
}

/**
 * Écran d'attente.
 *
 * Sans clé publique, l'application ne peut rien attester : elle le dit
 * franchement plutôt que d'offrir un bouton qui échouerait. C'est la seule
 * opération qui exige le réseau, et **une seule fois** — ensuite le contrôle se
 * fait entièrement hors ligne.
 */
export function EcranAccueil({ cle, onScanner }: ProprietesAccueil) {
  const prete = cle !== null;

  return (
    <div className="verify-ecran" data-verdict="attente">
      <div className="verify-verdict">
        <span className="verify-verdict__icone" aria-hidden="true">
          ⌖
        </span>
        <h1 className="verify-verdict__mot">Contrôle</h1>
        <p className="verify-verdict__explication">
          {prete
            ? 'Scannez le QR Code du titre, ou saisissez son contenu à la main.'
            : 'Première mise en service : connectez-vous une fois au réseau pour installer la clé de vérification.'}
        </p>

        {!prete && (
          <p className="verify-reserve">
            Sans cette clé, aucun titre ne peut être attesté. Elle ne s’installe qu’une fois ;
            ensuite, l’application fonctionne sans réseau.
          </p>
        )}
      </div>

      {prete && (
        <dl className="verify-detail">
          <div>
            <dt>Clé de vérification</dt>
            <dd>{cle.empreinte}</dd>
          </div>
        </dl>
      )}

      <div className="verify-actions">
        <button
          type="button"
          className="verify-bouton verify-bouton--principal"
          disabled={!prete}
          onClick={onScanner}
        >
          Contrôler un titre
        </button>
      </div>
    </div>
  );
}
